import React from 'react';
import PropTypes from 'prop-types';
import Script from 'next/script';
import { CookieCompliance, CookieComplianceCategories } from '@deporvillage/utils-library-component';
import { CartContext } from '../../../context/cart/context';

const getTrackingEvent = (page, model) => {
    switch (page) {
        case 'product':
            return { item: model.id.toString() };
        case 'subcategory':
        case 'category':
            return { category: model.name };
        default:
            return {};
    }
};

/* eslint-disable no-underscore-dangle */
const trackView = (id, page, model, hashEmail) => {
    window._etmc.push(['setOrgId', id]);
    if (hashEmail) window._etmc.push(['setUserInfo', { email: hashEmail }]);
    window._etmc.push(['trackPageView', getTrackingEvent(page, model)]);
};

const trackCart = (id, model, hashEmail) => {
    window._etmc.push(['setOrgId', id]);
    // istanbul ignore if
    if (hashEmail) window._etmc.push(['setUserInfo', { email: hashEmail }]);
    window._etmc.push(['trackCart', { cart: model }]);
};
/* eslint-enable no-underscore-dangle */

const mapCartItem = ({
    id, default_variant: variant, quantity, sku,
}) => ({
    item: id.toString(),
    quantity,
    unique_id: sku,
    price: variant?.price?.price,
});

const Sfmc = ({ id, model, page }) => {
    const mounted = React.useRef(false);
    const [cartData] = React.useContext(CartContext);
    const [hashEmail, setHashEmail] = React.useState(null);
    const [isInit, setInit] = React.useState(false);

    const handleUserData = (data) => {
        window.removeEventListener('user:data', handleUserData);
        const hashEmail = data.detail?.logged_in && data.detail?.hash_email;
        setHashEmail(hashEmail);
        trackView(id, page, model, hashEmail);
    };

    const handleInit = (canRun) => mounted.current && setInit(canRun);

    React.useEffect(() => {
        if (cartData?.isOpened) {
            const model = cartData.items.map(mapCartItem);
            trackCart(id, model, hashEmail);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cartData]);

    /* eslint-disable no-underscore-dangle */
    React.useEffect(() => {
        mounted.current = true;
        // istanbul ignore next
        if (!id) return null;
        CookieCompliance(handleInit, CookieComplianceCategories.Targeting);
        window._etmc = window._etmc || [];
        window.addEventListener('user:data', handleUserData);
        window.dispatchEvent(new CustomEvent('user:getdata'));
        return () => {
            window.removeEventListener('user:data', handleUserData);
            mounted.current = false;
        };
        /* eslint-disable-next-line react-hooks/exhaustive-deps */
    }, []);
    /* eslint-enable no-underscore-dangle */

    return id && isInit && (
        <Script
            id={'frontend-common-sfmc'}
            src={`//${id}.collect.igodigital.com/collect.js`}
            strategy={'afterInteractive'}
        />
    );
};

Sfmc.propTypes = {
    id: PropTypes.string,
    model: PropTypes.object,
    page: PropTypes.string,
};

export default Sfmc;
